/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class GrupoAcesso {
  constructor () {
    this.grupo_acesso_id = uuidV4()
    this.descricao = ''
    this.grupo_aceeso_permissoes = []
  }
}
